import { api } from "../../../utils/api";
import { TOKEN } from "../../../utils/localStorage";
import { getCookie } from "cookies-next";

export const getChecklistListApi = async (data) => {
  return await api.get(
    `/checklist-submission/list?department_id=${data?.department_id}&vessel_id=${data?.vessel_id}&startDate=${data?.startDate}&endDate=${data?.endDate}&limit=${data?.limit}&offset=${data?.offset}&checklist_type=${data?.checklist_type}`,
    {
      headers: {
        Authorization: `Bearer ${getCookie(TOKEN)}`,
      },
    }
  );
};

export const getChecklistQuestionAnswerListApi = async (checklist_id) => {
  return await api.get(
    `/checklist-question-answer/list/by-checklist-submissions-id?checklist_submission_id=${checklist_id}`,
    {
      headers: {
        Authorization: `Bearer ${getCookie(TOKEN)}`,
      },
    }
  );
};

export const deleteChecklistQuestionApi = async (itemId) => {
  return await api.delete(`/checklist-question/delete/${itemId}`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const getChecklistDefectsListByIDApi = async (checklist_id) => {
  return await api.get(`/checklist-submission/${checklist_id}`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};
